var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"title":"Manual Charge","items":_vm.invoice,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }